import { theme } from '../theme';

// LimitModal — extracted from Dashboard.js's existing inline modal
// (Aug 19, per Ali's report — items 2/3/4 of the parked-items list).
// Same shell as before (dark overlay, centered white card, sharp
// corners) but with two real fixes: the header no longer says
// "Premium feature" and the CTA no longer links to a dead "See
// Premium" page — neither has meant anything since the Aug 19 pin-
// limit rework removed the premium tier entirely. Replaced with a
// single "Got it" acknowledgment button, matching what Ali actually
// described wanting. Extracted into its own file specifically so
// Dashboard.js and PinTrip.js can share the one real component instead
// of each keeping their own copy — that was the explicit point of
// item 3, not just a styling fix.
//
// Extended (Aug 31, per Ali's report — Phase A of the pin-purchase
// build) with an optional second action button. ctaLabel/onCta are
// both optional — when omitted, this renders exactly as before (just
// "Got it"). When provided (see PinTrip.js's PIN_LIMIT_REACHED
// handling), a real "Buy 3 more pins" action sits alongside the plain
// dismiss, rather than every limit hitting a dead end.
//
// title/icon extended (Sep 15, per Ali's report) — genuinely generic
// confirm-shell now, not just a limit-specific one; Dashboard.js's
// delete confirmation reuses this exact same component with its own
// title/icon rather than a second, near-identical modal existing
// side by side with this one. Both default to the original
// limit-reached values, so every existing caller renders unchanged.
export default function LimitModal({ message, onClose, ctaLabel, onCta, title = 'Limit reached', icon = '⚠️' }) {
  if (!message) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px'
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: theme.surface, border: `2px solid ${theme.border}`, borderRadius: '0px', padding: '28px 24px',
          maxWidth: '360px', width: '100%', textAlign: 'center'
        }}
      >
        <div style={{ fontSize: '32px', marginBottom: '8px' }}>{icon}</div>
        <div style={{ fontFamily: theme.fontDisplay, fontWeight: 700, fontSize: '17px', color: theme.textPrimary, marginBottom: '10px' }}>
          {title}
        </div>
        <div style={{ fontSize: '13.5px', color: theme.textMuted, lineHeight: 1.5, marginBottom: '22px' }}>
          {message}
        </div>
        {ctaLabel && onCta ? (
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={onCta}
              style={{
                flex: 1, background: theme.action, color: '#1a1a1a', border: 'none',
                fontFamily: theme.fontDisplay, fontWeight: 700, fontSize: '13.5px',
                padding: '12px', borderRadius: '0px', cursor: 'pointer'
              }}
            >
              {ctaLabel}
            </button>
            <button
              onClick={onClose}
              style={{
                flex: 1, background: '#fff', color: theme.textPrimary, border: `2px solid ${theme.border}`,
                fontFamily: theme.fontDisplay, fontWeight: 700, fontSize: '13.5px',
                padding: '12px', borderRadius: '0px', cursor: 'pointer'
              }}
            >
              Not now
            </button>
          </div>
        ) : (
          <button
            onClick={onClose}
            style={{
              display: 'block', width: '100%', background: theme.action, color: '#1a1a1a', border: 'none',
              fontFamily: theme.fontDisplay, fontWeight: 700, fontSize: '14px',
              padding: '12px', borderRadius: '0px', cursor: 'pointer'
            }}
          >
            Got it
          </button>
        )}
      </div>
    </div>
  );
}